<script>
import TopBar from '@components/top-bar'
import Footer from '@components/footer'
import OnlineStatus from "@components/global/OnlineStatus";
import SubscriptionExpiration from "@components/global/SubscriptionExpiration";
import SmsThresholdApproaching from "@components/global/SmsThresholdApproaching";
import {mapState} from "vuex";
import PageHeader from "@components/page-header";
import MissingPhone from "@components/global/MissingPhone.vue";
import SmartPromptsPanel from "@components/global/SmartPromptsPanel.vue";
import AthleteFinancialsPanel from "@components/global/AthleteFinancialsPanel.vue";

export default {
  components: {MissingPhone, PageHeader, SubscriptionExpiration, TopBar, Footer, OnlineStatus, SmsThresholdApproaching, SmartPromptsPanel, AthleteFinancialsPanel },
  computed:{
    ...mapState({
      user: state => state.auth.currentUser,
      userSettings: state => state.settings.userSettings,
    }),
    showSmartPrompts() {
      return !this.isEducational && this.userSettings?.ai_prompts !== false;
    },
  },
  created: () => {
    document.body.classList.remove('authentication-bg');
    document.body.classList.remove('authentication-bg-pattern');
  },
}
</script>

<template>
  <div class="d-flex flex-column" style="min-height: 100vh;">
    <header id="topnav">
      <TopBar/>
    </header>

    <div class="wrapper">
      <div class="container-fluid">
        <sms-threshold-approaching />
        <subscription-expiration v-if="user" :key="user.subscriptionDue" />
        <missing-phone v-if="user" />
        <PageHeader />
        <slot />
      </div>
    </div>

    <Footer />
    <OnlineStatus/>
    <SmartPromptsPanel v-if="showSmartPrompts" />
    <AthleteFinancialsPanel />
  </div>
</template>
